import React from 'react';

import { StyledLazyLoaderWrapper, Loader, LoaderItem } from './styled';

const LazyLoader = () => {
  return (
    <StyledLazyLoaderWrapper>
      <Loader>
        <LoaderItem />
        <LoaderItem />
        <LoaderItem />
      </Loader>
    </StyledLazyLoaderWrapper>
  );
};

export default LazyLoader;
